/**
 * Capabilities Card Component
 * Displays what the AI agent can do for users
 */

import "./capabilities-card.scss";
import GradientText from "../gradient-text/GradientText";

export function CapabilitiesCard() {
  return (
    <div className="capabilities-card">
      <div className="card-header">
        <div className="header-content">
          <GradientText
            colors={["#40ffaa", "#4079ff", "#40ffaa", "#4079ff", "#40ffaa"]}
            animationSpeed={3}
            showBorder={false}
            className="gradient-header"
          >
            <span className="material-symbols-outlined icon">auto_awesome</span>
            <h2>What I Can Do</h2>
          </GradientText>
        </div>
        <div className="last-updated">
          <span className="material-symbols-outlined">schedule</span>
          <span>Last updated: 03/11/2025</span>
        </div>
      </div>
      
      <div className="card-body">
        <div className="capability-item">
          <span className="material-symbols-outlined">waving_hand</span>
          <div className="capability-text">
            <strong>Start with a greeting</strong>
            <p>Just say "Hi" to begin our conversation</p>
          </div>
        </div>

        <div className="capability-item">
          <span className="material-symbols-outlined">badge</span>
          <div className="capability-text">
            <strong>Provide your User ID</strong>
            <p>Use any ID from LM001 to LM010 for testing</p>
          </div>
        </div>

        <div className="capability-item">
          <span className="material-symbols-outlined">query_stats</span>
          <div className="capability-text">
            <strong>Request comparison graphs</strong>
            <p>Ask me to visualize data when comparing values</p>
          </div>
        </div>

        <div className="capability-item">
          <span className="material-symbols-outlined">mail</span>
          <div className="capability-text">
            <strong>Send emails</strong>
            <p>Request emails to your registered address or any other</p>
          </div>
        </div>

        <div className="capability-item">
          <span className="material-symbols-outlined">edit_note</span>
          <div className="capability-text">
            <strong>Update your information</strong>
            <p>Change contact details, address, or language preferences</p>
          </div>
        </div>

        <div className="capability-item">
          <span className="material-symbols-outlined">translate</span>
          <div className="capability-text">
            <strong>Multilingual support</strong>
            <p>I can communicate in Hindi, English, Tamil, and more</p>
          </div>
        </div>
      </div>

      <div className="card-footer">
        <span className="material-symbols-outlined">info</span>
        <p>Connect and unmute to start talking with Trezr</p>
      </div>
    </div>
  );
}
